export default "__VITE_ASSET__wn3mZ0Le__"